import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { CalculatorResultProvider } from "./context/CalculatorResultContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import BespaarcheckPopup from "./components/BespaarcheckPopup";

import Home from "./pages/Home";
import Thuisbatterijen from "./pages/Thuisbatterijen";
import AegPlugPlay from "./pages/AegPlugPlay";
import Zonnepanelen from "./pages/Zonnepanelen";
import Zakelijk from "./pages/Zakelijk";
import Werking from "./pages/Werking";
import Installatie from "./pages/Installatie";
import Merken from "./pages/Merken";
import Reviews from "./pages/Reviews";
import OverOns from "./pages/OverOns";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import DuurzaamFinancieren from "./pages/DuurzaamFinancieren";
import Laadpalen from "./pages/Laadpalen";
import AdsThuisbatterij from "./pages/AdsThuisbatterij";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // wait next paint
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
};

const GoogleAnalyticsTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
    <WhatsAppButton />
    <BespaarcheckPopup />
  </>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <CalculatorResultProvider>
          <BrowserRouter>
          <ScrollToTop />
          <GoogleAnalyticsTracker />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/thuisbatterij" element={<AdsThuisbatterij />} />
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/thuisbatterijen" element={<PublicLayout><Thuisbatterijen /></PublicLayout>} />
            <Route path="/aeg-plug-play" element={<PublicLayout><AegPlugPlay /></PublicLayout>} />
            <Route path="/zonnepanelen" element={<PublicLayout><Zonnepanelen /></PublicLayout>} />
            <Route path="/zakelijk" element={<PublicLayout><Zakelijk /></PublicLayout>} />
            <Route path="/werking" element={<PublicLayout><Werking /></PublicLayout>} />
            <Route path="/installatie" element={<PublicLayout><Installatie /></PublicLayout>} />
            <Route path="/duurzaam-financieren" element={<PublicLayout><DuurzaamFinancieren /></PublicLayout>} />
            <Route path="/laadpalen" element={<PublicLayout><Laadpalen /></PublicLayout>} />
            <Route path="/merken" element={<PublicLayout><Merken /></PublicLayout>} />
            <Route path="/reviews" element={<PublicLayout><Reviews /></PublicLayout>} />
            <Route path="/over-ons" element={<PublicLayout><OverOns /></PublicLayout>} />
            <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
        </CalculatorResultProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
